export const getNextUppercaseLabel = (label) => {
    const next = String.fromCharCode(label.charCodeAt(label.length - 1) + 1);
    return next.length > label.length ? "A" + next : label.slice(0, -1) + next;
};

// Helper to generate the next lowercase label
export const getNextLowercaseLabel = (label) => {
    const next = String.fromCharCode(label.charCodeAt(label.length - 1) + 1);
    return next.length > label.length ? "a" + next : label.slice(0, -1) + next;
};

export const generateNextLabel = (labelType, lastLabel) => {
    switch (labelType) {
        case "AA":
            return lastLabel
                ? getNextUppercaseLabel(lastLabel)
                : "A"; // Start with "AA"
        case "aa":
            return lastLabel
                ? getNextLowercaseLabel(lastLabel)
                : "a"; // Start with "aa"
        case "123":
        default:
            return lastLabel
                ? (parseInt(lastLabel) + 1).toString()
                : "1"; // Start with "1"
    }
};

export const reorderLabels = (values, labelType) => {
    const generateLabel = (index) => {
        if (labelType === "123") {
            return (index + 1).toString(); // Numbers starting from 1
        } else if (labelType === "AA") {
            let label = "";
            let num = index;
            while (num >= 0) {
                label = String.fromCharCode((num % 26) + 65) + label; // A-Z
                num = Math.floor(num / 26) - 1;
            }
            return label;
        } else if (labelType === "aa") {
            let label = "";
            let num = index;
            while (num >= 0) {
                label = String.fromCharCode((num % 26) + 97) + label; // a-z
                num = Math.floor(num / 26) - 1;
            }
            return label;
        }
    };

    // Reassign labels based on the label type
    return values.map((item, index) => ({
        ...item,
        label: generateLabel(index),
    }));
};

export const sortOptions = (options) => {
    return options.sort((a, b) => a.label.localeCompare(b.label));
};
